<template>
  <div :class="$style.host">
    <v-btn
      color="primary"
      class="unr-button"
      @click="setRegistrationStep"
    >
      New User Registration
    </v-btn>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { SET_REGISTRATION_STEP } from '@/features/registration/store/modules/registration';

export default {
  name: 'DistributorNewButton',
  methods: mapMutations({
    setRegistrationStep: SET_REGISTRATION_STEP,
  }),
};
</script>

<style lang="scss" module>
.host {
  margin-top: 25px;
}
</style>
